import React, { useRef } from "react";
import useMenuStore from "stores/menuStore";
import classNames from "classnames";

import { MENU_BEHAVIOUR, MENU_PLACEMENT } from "../../utils/constant";
import NavUserMenu from "./NavUserMenu";
import NavIconMenu from "./NavIconMenu";
import MainMenu from "./main-menu/MainMenu";
import NavLogo from "./NavLogo";
import NavMobileButtons from "./NavMobileButtons";

const DELAY = 80;

const Nav = () => {
  const {
    navClasses,
    placementStatus,
    behaviourStatus,
    attrMobile,
    menuPadding,
    menuChangeAttrMenuAnimate,
    menuChangeCollapseAll,
  } = useMenuStore();
  const mouseActionTimer = useRef(null);

  // Vertical menu semihidden state showing
  // Only works when the vertical menu is active and mobile menu closed
  const onMouseEnterDelay = () => {
    if (
      placementStatus.placementHtmlData === MENU_PLACEMENT.Vertical &&
      behaviourStatus.behaviourHtmlData === MENU_BEHAVIOUR.Unpinned &&
      attrMobile !== true
    ) {
      menuChangeCollapseAll(false);
      menuChangeAttrMenuAnimate("show");
    }
  };

  // Delayed one that hides or shows the menu. It's required to prevent collapse animation getting stucked
  const onMouseEnter = () => {
    if (mouseActionTimer.current) clearTimeout(mouseActionTimer.current);

    mouseActionTimer.current = setTimeout(() => {
      onMouseEnterDelay();
    }, DELAY);
  };

  // Vertical menu semihidden state hiding
  // Only works when the vertical menu is active and mobile menu closed
  const onMouseLeaveDelay = () => {
    if (
      placementStatus.placementHtmlData === MENU_PLACEMENT.Vertical &&
      behaviourStatus.behaviourHtmlData === MENU_BEHAVIOUR.Unpinned &&
      attrMobile !== true
    ) {
      menuChangeCollapseAll(true);
      menuChangeAttrMenuAnimate("hidden");
    }
  };

  const onMouseLeave = () => {
    if (mouseActionTimer.current) clearTimeout(mouseActionTimer.current);
    mouseActionTimer.current = setTimeout(() => {
      onMouseLeaveDelay();
    }, DELAY);
  };
  // eslint-disable-next-line react/self-closing-comp
  <div className="col-lg-3 col-md-4 col-6"></div>;
  return (
    <div
      id="nav"
      className={classNames("nav-container d-flex", navClasses)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className="nav-content d-flex"
        style={
          placementStatus.placementHtmlData === MENU_PLACEMENT.Horizontal &&
          menuPadding
            ? { paddingRight: menuPadding }
            : {}
        }
      >
        <NavLogo />
        <NavUserMenu />
        <NavIconMenu />
        <MainMenu />
        <NavMobileButtons />
      </div>
      <div className="nav-shadow" />
    </div>
  );
};
export default React.memo(Nav);
